export const typography = {
  'typo-title-xxl': 'typo-title-xxl',
  'typo-title-xxl-bold': 'typo-title-xxl-bold',
  'typo-title-xxl-semibold': 'typo-title-xxl-semibold',
  'typo-title-xxl-medium': 'typo-title-xxl-medium',

  'typo-title-xl-bold': 'typo-title-xl-bold',
  'typo-title-xl-medium': 'typo-title-xl-medium',
  'typo-title-xl-semibold': 'typo-title-xl-semibold',

  'typo-title-l-bold': 'typo-title-l-bold',
  'typo-title-l-medium': 'typo-title-l-medium',
  'typo-title-l-semibold': 'typo-title-l-semibold',

  'typo-title-m-bold': 'typo-title-m-bold',
  'typo-title-m-medium': 'typo-title-m-medium',
  'typo-title-m-semibold': 'typo-title-m-semibold',

  'typo-title-s-bold': 'typo-title-s-bold',
  'typo-title-s-medium': 'typo-title-s-medium',
  'typo-title-s-semibold': 'typo-title-s-semibold',

  'typo-title-xs-bold': 'typo-title-xs-bold',
  'typo-title-xs-medium': 'typo-title-xs-medium',
  'typo-title-xs-semibold': 'typo-title-xs-semibold',

  'typo-text-xxl': 'typo-text-xxl',
  'typo-text-xxl-bold': 'typo-text-xxl-bold',
  'typo-text-xxl-medium': 'typo-text-xxl-medium',
  'typo-text-xxl-semibold': 'typo-text-xxl-semibold',

  'typo-text-xl': 'typo-text-xl',
  'typo-text-xl-bold': 'typo-text-xl-bold',
  'typo-text-xl-medium': 'typo-text-xl-medium',
  'typo-text-xl-semibold': 'typo-text-xl-semibold',

  'typo-text-l': 'typo-text-l',
  'typo-text-l-bold': 'typo-text-l-bold',
  'typo-text-l-medium': 'typo-text-l-medium',
  'typo-text-l-semibold': 'typo-text-l-semibold',

  'typo-text-m': 'typo-text-m',
  'typo-text-m-bold': 'typo-text-m-bold',
  'typo-text-m-medium': 'typo-text-m-medium',
  'typo-text-m-semibold': 'typo-text-m-semibold',

  'typo-text-s': 'typo-text-s',
  'typo-text-s-bold': 'typo-text-s-bold',
  'typo-text-s-medium': 'typo-text-s-medium',
  'typo-text-s-semibold': 'typo-text-s-semibold',

  'typo-text-xs': 'typo-text-xs',
  'typo-text-xs-medium': 'typo-text-xs-medium',
  'typo-text-xs-bold': 'typo-text-xs-bold',
  'typo-text-xs-semibold': 'typo-text-xs-semibold',

  'typo-text-xxs': 'typo-text-xxs',
  'typo-text-xxs-medium': 'typo-text-xxs-medium',
  'typo-text-xxs-semibold': 'typo-text-xxs-semibold',
} as const;
